import './style.scss';
import arrowLeft from '../../Images/Common/arrow-small-left.svg';
import LogoutIconLarge from '../../Images/sidebar/LogoutIconLarge.svg';
import { Tooltip } from 'antd';

export default function Button_One({
  height,
  width,
  text,
  handleClick,
  customClass,
  fontSize,
  toolTipText,
  toolTipPlacement,
}) {
  return (
    <Tooltip title={toolTipText} placement={toolTipPlacement}>
      <button
        className={`button-one ${customClass ? customClass : ''}`}
        onClick={handleClick}
        style={{
          height: height,
          width: width,
          fontSize: fontSize,
        }}
      >
        {text}
      </button>
    </Tooltip>
  );
}

export function Button_Disabled({ height, width, bgcolor, text }) {
  return (
    <button
      className="button-disabled"
      style={{
        height: height,
        width: width,
        backgroundColor: bgcolor,
      }}
    >
      {text}
    </button>
  );
}

export function Button_Two({
  height,
  width,
  text,
  handleClick,
  customClass,
  children,
}) {
  return (
    <button
      className={`button-two  ${customClass ? customClass : ''}`}
      onClick={handleClick}
      style={{
        height: height,
        width: width,
      }}
    >
      {text}
      {children}
    </button>
  );
}

export function BackButton({
  height,
  width,
  text,
  handleClick,
  customClass,
  toolTip,
  toolTipText,
}) {
  return (
    <Tooltip title={toolTipText} placement="top">
      <button
        className={`button-back ${customClass ? customClass : ''}`}
        onClick={handleClick}
        style={{
          height: height,
          width: width,
        }}
      >
        <img src={arrowLeft} alt="back-icon" />
      </button>
    </Tooltip>
  );
}

export function LoginButton({
  height = '10px',
  width = '10px',
  text,
  handleClick,
}) {
  return (
    <button
      className="login_btn"
      onClick={handleClick}
      style={{
        height: height,
        width: width,
      }}
    >
      <img src={LogoutIconLarge} alt="logoutIcon" /> {text}
    </button>
  );
}
